import React from 'react';
import './ImageCollection.css';
import img1 from '../../assets/images/creations/table_cloth/tc_2.png';
import img2 from '../../assets/images/creations/accessory/hat_1.png';
import img3 from '../../assets/images/creations/bags/bag_3.png';
import img4 from '../../assets/images/creations/home_decor/pillow.jpg';

const images = [
  { id: 1, src: img4, caption: 'Pillow Covers' },
  { id: 2, src: img2, caption: 'Beanie' },
  { id: 3, src: img3, caption: 'Bags' },
  { id: 4, src: img1, caption: 'Table Runner' },

];

function ImageCollection(): React.ReactElement {
  return (
    <section className="image-collection" id="gallery">
      <div className="image-collection-decor image-collection-decor-tl" />
      <div className="image-collection-decor image-collection-decor-br" />
      <div className="image-collection-inner">
        <h2 className="image-collection-title">THE PRODUCT RANGE</h2>
        <p className="image-collection-subtitle">of Woollen Crochet</p>
        <div className="image-collection-grid">
          {images.map((img) => (
            <div key={img.id} className="image-collection-item">
              <div className="image-collection-frame">
                <img src={img.src} alt={img.caption} className="image-collection-img" />
              </div>
              <span className="image-collection-caption">{img.caption}</span>
            </div>
          ))}
        </div>
        <footer className="image-collection-footer">
          <div className="image-collection-footer-line" />
          <p className="image-collection-url">www.trupzlooplet.in</p>
        </footer>
      </div>
    </section>
  );
}

export default ImageCollection;
